import { fal } from "@fal-ai/client";
import { uploadGeneratedImage } from '../../firebase/storage';
import { saveEditedImage } from '../../firebase/db/edit';

// Initialize Fal client with API key and base URL
fal.config({
  credentials: import.meta.env.VITE_FAL_KEY,
  baseUrl: import.meta.env.DEV ? '/fal-api' : 'https://api.fal.ai'
});

export async function editImage(imageUrl: string, prompt: string, userId: string): Promise<string> {
  try {
    const result = await fal.subscribe("fal-ai/flux-pro/kontext/max", {
      input: {
        prompt,
        image_url: imageUrl,
        guidance_scale: 3.5,
        num_images: 1,
        safety_tolerance: "2",
        output_format: "jpeg"
      }
    });

    if (!result.data?.images?.[0]?.url) {
      throw new Error('No image generated');
    }

    // Upload to Firebase Storage
    const editedImageUrl = await uploadGeneratedImage(
      userId,
      result.data.images[0].url,
      'edited'
    );

    // Save to Firestore
    await saveEditedImage(userId, {
      originalImageUrl: imageUrl,
      editedImageUrl,
      prompt,
      createdAt: new Date(),
      metadata: {
        type: 'edit',
        timestamp: Date.now()
      }
    });

    return editedImageUrl;
  } catch (error) {
    console.error('Fal API error:', error);
    throw new Error(`Edit failed: ${error instanceof Error ? error.message : 'API request failed'}`);
  }
}